module.exports = __webpack_public_path__ + "static/media/info-blue@2x.51073fa1.svg";